﻿import { SaopViewForm } from "../core/saop-view-form";

export class SaopRegKeZapDopustiView extends SaopViewForm {
    constructor(viewId: string, libName: string = "") {
        super(viewId, libName);
        this.setDictionary();                
        this.title = this.translationService.translate("Odsotnost");        
        this.addRecordEndpoint = "KeZapDopusti/CreateKeZapDopusti";
        this.editRecordEndpoint = "";
        this.deleteRecordEndpoint = "KeZapDopusti/DeleteKeZapDopusti";
    }  
    
    setDictionary(){
        let dictionary:string[] = ["Odsotnost","Ali ste prepričani, da želite izbrisati odsotnost?"];
        this.setTerminologyList(dictionary);
    }     
}


